import React from 'react';
import {
  Box,
  Grid,
  Typography,
  Paper,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Container,
  useMediaQuery,
  useTheme,
  Divider,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import imgUrl from '../../assets/images/imgUrl';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const imgUrls = [
  imgUrl.fincirc,
  imgUrl.balpharma,
  imgUrl.ecube,
  imgUrl.whiteSpoons,
  imgUrl.pharmveda,
  imgUrl.chablani,
  imgUrl.enersynk,
  imgUrl.pecan,
  imgUrl.kridzz,
  imgUrl.deal,
  imgUrl.blackSwan,
  imgUrl.kurves,
  imgUrl.siroya,
  imgUrl.stivaph,
];

const data = {
  tiers: [
    { name: 'Platinum', price: '$12,000' },
    { name: 'Gold', price: '$7,000' },
    { name: 'Silver', price: '$4,000' },
    { name: 'Bronze', price: '$2,100' },
  ],
  benefits: [
    {
      category: 'Stage Felicitation',
      items: [{ label: 'With I Am Peacekeeper Chief Guests', values: ['Yes', 'Yes', 'No', 'No'] }],
    },
    {
      category: 'Logo at Event',
      items: [
        { label: 'Static throughout the event', values: ['2', '2', '1', '1'] },
        { label: 'Appears digitally on screen', values: ['5', '4', '3', '1'] },
        { label: 'Total', values: ['7', '6', '4', '2'] },
      ],
    },
    {
      category: 'Online Mentions',
      items: [
        { label: 'IAPM Website', values: ['Yes', 'Yes', 'Yes', 'Yes'] },
        { label: 'IAPM Social Media', values: ['Yes', 'Yes', 'No', 'No'] },
      ],
    },
    {
      category: 'Press Release',
      items: [{ label: 'Released with Press Note', values: ['Yes', 'Yes', 'No', 'No'] }],
    },
    {
      category: 'Stall',
      items: [{ label: 'Allocated Exclusive Stall', values: ['Yes', 'No', 'No', 'No'] }],
    },
    {
      category: 'Exclusive Session',
      items: [
        {
          label: (
            <>
              Coffee & Conversation with <br />
              Professor Mohan Munasinghe <br />
              (5:30–6:30 PM GST <br />
              Taj Business Bay)
            </>
          ),
          values: ['Yes', 'No', 'No', 'No'],
        },
      ],
    },
  ],
};

const guests = [

  {
    name: 'Dr. Asle Toje',
    description:
      <>
        <b>Vice Chair (Deputy Leader),</b>  <i>Norwegian Nobel Committee</i> ; <b>Member</b> <b>2018–2029</b> ; former <b>Research Director,</b>
        <i>Norwegian Nobel Institute</i>.
      </>

  },
  {
    name: 'His Excellency Sheikh Awad Mohammed bin Sheikh Mejren',
    description: <>
      <b> Founder, </b> <i>Emirates Travellers </i>  🌍; <b>Chairman,</b> <i>Emirates Travellers Festival</i>.
    </>
  },
  {
    name: 'His Excellency Dr. Khalid Ghanem Al Ghaith',
    description:
      <>
        <b>Secretary-General,</b> <i>Higher Committee of Human Fraternity (HCHF) Abu Dhabi</i>
      </>

  },
  {
    name: 'His Excellency Mirza Hussain Al Sayegh',
    description:
      <>
        <b>Member,</b> <i>Board of Trustees, Al Maktoum Foundation, UAE;</i> <b>Chairman,</b> <i>Al-Maktoum College of Higher Education, Dundee (UK)</i>
      </>

  },
  {
    name: 'His Excellency Dr. Mohammed Saeed Al Kindi',
    description:
      <>
        former <b>Minister of Environment and Water</b> <i>UAE</i>
      </>

  },
  {
    name: 'Professor Mohan Munasinghe - 2007',
    description: <>
      <i>Nobel Peace Prize </i> <b> Co-Laureate (Vice-Chair,</b> <i>IPCC</i>) ; <b>2021 </b> <i>Blue Planet Prize  🌊</i>; <b>Founder-Chairman, </b>
      <i>MIND</i>.
    </>
  },
  {
    name: 'Honourable Ms. Ouided Bouchamaoui',
    description: <>
      <b>2015 </b> <i>Nobel Peace Laureate  (Tunisian National Dialogue Quartet)</i>; Former <b>President</b>, <i>UTICA</i> .
    </>
  },
  {
    name: 'Dr. Siddeek Ahmed',
    description:
      <>
        <b>Chairman & Managing Director, </b><i>Eram Holdings; </i> <b>Co-Chair</b> <i>FICCI Arab Council</i> <b>2021</b> <i>Pravasi Bharatiya Samman Award</i> <b>winner.</b>
      </>
  },
  {
    name: 'His Excellency Yaqoob Al Ali',
    description:
      <>
        <b>Executive Director & Private Advisor</b> <i>Office of His Highness Sheikh Juma Bin Maktoum Al Maktoum</i> ; <b>Executive Chairman</b> <i>Al Ali Group (UAE).</i>
      </>
  },
];

const platinumAccounts = [
  {
    subTitle: 'For USD Payments',
    details: [
      'Bank Name: First Abu Dhabi Bank PJSC (FAB)',
      'Account Number: 1001326744366002',
      'IBAN: AE580351001326744366002',
      'Currency: USD',
      'SWIFT/Code: NBADAEAA',
      'Branch: Sheikh Zayed Road, Al Quoz 3, Dubai, UAE',
    ],
  },
  {
    subTitle: 'For AED Payments',
    details: [
      'Bank Name: First Abu Dhabi Bank PJSC (FAB)',
      'Account Number: 1001326744366001',
      'IBAN: AE850351001326744366001',
      'Currency: AED',
      'SWIFT/Code: NBADAEAA',
      'Branch: Sheikh Zayed Road, Al Quoz 3, Dubai, UAE',
    ],
  },
];

const otherTiersAccounts = [
  {
    subTitle: 'For USD Payments',
    details: [
      'Name of Bank:  WIO PJSC',
      'Account Holder: JUPITER EVENTS L.L.C',
      'IBAN: AE840860000009332725809',
      'BIC/SWIFT: WIOBAEADXXX',
      'Business Address: Etihad Airways Centre, 5th Floor Abu Dhabi, UAE',
      'Al Ittihad Road, Deira, Dubai, UAE',
      'Correspondent Bank Name: Citibank',
      'NABIC/SWIFT Code: CITIUS33XXX',
    ],
  },
  {
    subTitle: 'For AED Payments',
    details: [
      'Name of Bank: WIO PJSC',
      'Account Holder: JUPITER EVENTS L.L.C',
      'IBAN: AE760860000009366914864',
      'BIC/SWIFT:  WIOBAEADXXX',
      'Business Address:  Etihad Airways Centre, 5th Floor Abu Dhabi, UAE'

    ],
  },
];

const PaymentSection = ({ title, accounts }) => (
  <div sx={{ mt: 4 }}>
    {title && (
      <Typography gutterBottom>
        {title}
      </Typography>
    )}
    {accounts.map((acc, idx) => (
      <div key={idx} sx={{ mt: 1, pl: 2 }}>
        <Typography fontWeight="bold" gutterBottom>
          {acc.subTitle}
        </Typography>
        <List dense sx={{ pl: 2 }}>
          {acc.details.map((item, index) => (
            <ListItem key={index} sx={{
              alignItems: 'flex-start',
              p: 0,
              '&::before': {
                content: '"•"',
                color: '#333',
                fontSize: '1.2rem',
                display: 'inline-block',
                width: '1rem',
                marginRight: '0.5rem',
              },
            }}>
              <ListItemText primary={<Typography variant="body2">{item}</Typography>} />
            </ListItem>
          ))}
        </List>
      </div>
    ))}
  </div>
);

const Events = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>


      {/* Event Hero Background */}
      <Box
        className="programEventSectionBg commonBannerBg"
        sx={{
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          color: 'white',
          px: 2,
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 80,
            left: 0,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Box component="img" src={imgUrl.doveImg} alt="Peace Dove Logo" sx={{ maxWidth: 200 }} />
        </Box>
      </Box>


      {/* Events Timeline */}
      <Box mt={5}>
        <Grid container direction="column" alignItems="center" spacing={2}>
          <Grid item xs={12} display="flex" flexDirection="column" alignItems="center">
            <img src={imgUrl.peaceIcon} className="w-100 peaceImg" />
            <Typography variant="h5" className="founder-title mainHeading green-title">
              <i>I Am Peacekeeper</i> Events
            </Typography>
          </Grid>
        </Grid>

        <Box className="waveBg event-ProgramSection" mt={3}>
          <Box className="timeline-container">
            {/* Event Cards */}
            {[{
              link: "https://justice-love-peace.com/",
              month: "April, 2025",
              day: "12th & 13th",
              img: imgUrl.justiceLogo,
              desc: `Landmark Occasion\nSaturday, 12th April 2025 and Sunday, 13th April 2025 — Global Justice, Love & Peace Summit, Dubai Expo City\n10 Nobel Peace Laureates; Peace Charter presented.`,
            }, {
              link: "https://i-am-peacekeeper.com/",
              day: "4th",
              month: "Sept, 2025",

              img: imgUrl.peaceMovImg,
              desc: `Momentous Launch\nThursday, 4th September 2025 — I Am Peacekeeper Movement , Dubai, 1:47 PM GST\nWebsite and App launch (Opera Ballroom, Taj Business Bay).`,
            }, {
              link: "https://billionaires-for-peace.com/",
              month: "April, 2026",
              day: "2nd",
              img: imgUrl.billionaireLogo,
              desc: `Forthcoming Prestige Conclave\nThursday, 2nd April 2026 — Billionaires for Peace Conclave , Dubai\n7 Nobel Peace Laureates; Gala Dinner; I Am Peacekeeper Charter.\n`,
            }].map((event, idx) => (
              <React.Fragment key={idx}>
                <Link href={event.link} target="_blank" className="cursor-pointer text-decoration-none">
                  <Paper elevation={3} className="event-card">
                    <Box className="circle-wrapper">
                      <Box className="date-circle yellow">
                        <Typography variant="h5" className="day">{event.day}</Typography>
                        <Typography variant="h6" className="month">{event.month}</Typography>

                      </Box>
                    </Box>
                    <Box className="event-content">
                      <div className="eventImg"><img src={event.img} /></div>
                      <Typography variant="body1" className="event-description">{event.desc}</Typography>
                    </Box>
                  </Paper>
                </Link>
                {/* Global Justice, Love & Peace Content Section - After first event */}
                {idx === 0 && (
                  <Box
                    className="globalEventcircle"
                    sx={{
                      width: '100%',
                      maxWidth: { xs: '100%', sm: '800px', md: '900px', lg: '1200px', xl: '1400px' },
                      mx: 'auto',
                      // mt: { xs: 4, sm: 5, md: 6 },
                      mb: { xs: 4, sm: 5, md: 6 },
                      px: { xs: 2, sm: 3, md: 4, lg: 5, xl: 6 },
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#f8f9fa',
                        borderRadius: { xs: '12px', sm: '16px', md: '20px' },
                        padding: { xs: 3, sm: 4, md: 5 },
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                        border: '1px solid #e9ecef',
                      }}
                    >
                      {/* Title */}
                      <Typography
                        variant="h4"
                        sx={{
                          fontSize: { xs: '1.75rem', sm: '2rem', md: '2.25rem' },
                          fontWeight: 700,
                          color: '#0A8270',
                          mb: 3,
                          textAlign: 'center',
                          fontFamily: 'var(--heading-font)',
                          lineHeight: 1.2,
                        }}
                      >
                        Global Justice, Love & Peace
                      </Typography>

                      {/* Opening Quote */}
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.35rem' },
                          fontStyle: 'italic',
                          color: '#43454b',
                          mb: 4,
                          textAlign: 'center',
                          fontFamily: 'var(--secondary-font)',
                          lineHeight: 1.6,
                          fontWeight: 300,
                        }}
                      >
                        Some gatherings feel like meetings. This one felt like a turning.
                      </Typography>

                      {/* Main Content */}
                      <Box sx={{ mb: 4 }}>
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.15rem' },
                            color: '#2c2e35',
                            mb: 3,
                            fontFamily: 'var(--default-font)',
                            lineHeight: 1.8,
                            textAlign: 'justify',
                          }}
                        >
                          On Saturday and Sunday, 12–13 April 2025, the Global Justice, Love & Peace Summit came alive at the Dubai Exhibition Centre (DEC) at Expo City, Dubai, from 10 AM to 11 PM. Chaired by Dr. Huzaifa Khorakiwala and honoured by H.E. Sheikh Nahyan bin Mubarak Al Nahyan, UAE Minister of Tolerance and Co-existence, the Summit welcomed an international constellation of speakers and delegates for two days of dialogue, reflection and connection.
                        </Typography>

                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.15rem' },
                            color: '#2c2e35',
                            mb: 3,
                            fontFamily: 'var(--default-font)',
                            lineHeight: 1.8,
                            textAlign: 'justify',
                          }}
                        >
                          Across sessions on Justice, Love & Peace, we explored how societies heal, how communities listen and how leaders serve without losing their humanity. Alongside the conversations, a special meditation session and a world yoga session created space to breathe, reset and remember what we are building together.
                        </Typography>

                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.15rem' },
                            color: '#2c2e35',
                            mb: 3,
                            fontFamily: 'var(--default-font)',
                            lineHeight: 1.8,
                            textAlign: 'justify',
                          }}
                        >
                          At the heart of it all stood our shared compass: <strong style={{ color: '#0A8270' }}>Truth, Gratitude, Forgiveness, Love, Humility, Giving and Patience</strong>. These are not slogans, they are practices and this Summit was our first major step in living them publicly and purposefully.
                        </Typography>
                      </Box>

                      {/* Closing Statement */}
                      <Box
                        sx={{
                          borderTop: '2px solid #d1de5f',
                          borderBottom: '2px solid #d1de5f',
                          py: 1,
                          mt: 4,
                          mb: 3,
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: '1.1rem', sm: '1.2rem', md: '1.3rem' },
                            color: '#0A8270',
                            fontWeight: 600,
                            textAlign: 'center',
                            fontFamily: 'var(--heading-font)',
                            lineHeight: 1.6,
                          }}
                        >
                          The closing lesson was simple: peace is not a conclusion, it is a daily craft.
                        </Typography>
                      </Box>

                      {/* Final Line */}
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: { xs: '0.95rem', sm: '1rem', md: '1.05rem' },
                          color: '#666',
                          textAlign: 'center',
                          fontFamily: 'var(--secondary-font)',
                          lineHeight: 1.6,
                          fontStyle: 'italic',
                        }}
                      >
                        The work continues, quietly, steadily and together.
                      </Typography>
                    </Box>
                  </Box>
                )}
              </React.Fragment>
            ))}
          </Box>
        </Box>
      </Box>

      {/* Chief Guests Section */}

      <Box className="eventBgSectionBlue" pb={2}>
        <Box pt={1}>


          <Box className="eventBg1" pt={4}>
            <Container maxWidth="lg" sx={{ my: 2, pb: 5 }}>
              <Grid container direction="column" alignItems="center" spacing={2}>
                <Grid item xs={12} display="flex" flexDirection="column" alignItems="center">
                  <img src={imgUrl.peaceIcon} className="w-100 peaceImg" />
                  <Typography variant="h5" className="founder-title mainHeading green-title">
                    Presenting the I Am Peacekeeper Movement  & <br></br> Global
                    Initiatives
                    {/* <i>I Am Peacekeeper</i>  Chief Guests */}
                  </Typography>
                </Grid>
              </Grid>

              <Box mt={2} display="flex" alignItems="center" justifyContent="center" flexDirection="column">

                <img src={imgUrl.eventProfileImg} className='w-100 eventProfile'></img>
                <img src={imgUrl.eventDateImg} className='w-100 eventProfileDate'></img>
                <Typography className='eventDescription'>Precise Time - 1:47 PM GST <br></br>
                  Opera Ballroom, Taj Business Bay, Dubai</Typography>
                <div className='border-bottom-blue'></div>

              </Box>
            </Container>
          </Box>
          <Box component="ul" sx={{ pl: 0, mt: 4, pt: 5 }} className="eventBg2">
            <Container maxWidth="lg" sx={{ my: 2, pb: 5 }}>
              <Grid container direction="column" alignItems="center" spacing={2}>
                <Grid item xs={12} display="flex" flexDirection="column" alignItems="center">
                  <img src={imgUrl.peaceIcon} className="w-100 peaceImg" />
                  <Typography variant="h5" className="founder-title mainHeading green-title">
                    <i>I Am Peacekeeper</i>  Chief Guests
                    {/* <i>I Am Peacekeeper</i>  Chief Guests */}
                  </Typography>
                </Grid>
              </Grid>
              {guests.map((guest, index) => (
                <Box key={index} sx={{ mb: 3, mt: 3 }} className="guestTypo">
                  <Typography variant="body2" sx={{
                    '&::before': {
                      content: '"•"',
                      color: '#333',
                      fontSize: '1.2rem',
                      display: 'inline-block',
                      width: '1rem',
                      marginRight: '0.5rem',
                      marginTop: '4px'
                    },
                  }} >
                    <strong>{guest.name} - </strong> {guest.description}
                  </Typography>
                </Box>
              ))}
            </Container>
          </Box>

        </Box>

        {/* Sponsorship Table */}
        {/* <Box sx={{  px: 2 }} pt={3} className="tableEvent eventBg3">
      <div className='border-small-bottom-blue' mb={3} mt={3}></div>
        <Container maxWidth="lg" mt={4} className='mt-50px'>
          <Typography className="subHeading" gutterBottom>
            4 clear paths to partner with impact; each tier carries stage visibility, verified digital mentions & curated networking
          </Typography>
          <TableContainer sx={{ borderRadius: 3, overflowX: 'auto', boxShadow: 3 }}>
            <Table size={isMobile ? 'small' : 'medium'} sx={{ minWidth: 600 }}>
              <TableHead>
                <TableRow sx={{ backgroundColor: '#ece8f9' }}>
                  <TableCell></TableCell>
                  {data.tiers.map((tier, index) => (
                    <TableCell key={index} align="center" sx={{ fontWeight: 'bold' }}>{tier.name}</TableCell>
                  ))}
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', color: '#003366' }}>
                    4<sup>th</sup> September Event Sponsorships
                  </TableCell>
                  {data.tiers.map((tier, index) => (
                    <TableCell key={index} align="center" sx={{ fontWeight: 'bold' }}>{tier.price}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.benefits.map((section, index) => (
                  <React.Fragment key={index}>
                    <TableRow>
                      <TableCell colSpan={5} sx={{ backgroundColor: '#21A5CC', color: 'white', fontWeight: 'bold' }}>
                        {section.category}
                      </TableCell>
                    </TableRow>
                    {section.items.map((item, i) => (
                      <TableRow key={i}>
                        <TableCell>{item.label}</TableCell>
                        {item.values.map((value, j) => (
                          <TableCell key={j} align="center">{value}</TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Container>
        <div className='border-small-bottom-blue' mb={3} mt={3} style={{marginTop:"30px"}}></div>
      </Box> */}


        {/* Payment Info */}
        {/* <Box mt={5} pt={5} pb={5} className="blueEventSection eventBg3">
        <Container maxWidth="lg">
          <Box>
            <Typography fontWeight="bold" gutterBottom>
              For Platinum (US $12,000)
            </Typography>
            <PaymentSection accounts={platinumAccounts} />

           

            <Typography  fontWeight="bold" gutterBottom>
              For Gold (US $7,000), Silver (US $4,000) & Bronze (US $2,000)
            </Typography>
            <PaymentSection accounts={otherTiersAccounts} />

           

            <Typography variant="body2" color="text.secondary">
              For <b>Payments via Credit Card, Debit Card, or Net Banking</b> in any Currency (USD, AED, INR, GBP, or others), please send a request specifying the desired 
              amount to: <Link to="mailto:gauravi@i-am-peacekeeper.com" className='cursor-pointer'>gauravi@i-am-peacekeeper.com</Link>.
            </Typography>

            <Typography variant="body2" color="text.secondary" mt={2}>
              We shall be provide you with a dedicated payment link.
            </Typography>

            <Typography variant="body2" color="text.secondary" mt={2}>
              For any further queries or assistance,  kindly contact: <br></br> 
              Gaurav on:  <Link
  href="https://wa.me/917506007533"
  target="_blank"
  rel="noopener noreferrer"
  underline="hover"
>+91-75060-07533, </Link>,  <Link to="mailto:gaurav@i-am-peacekeeper.com" className='cursor-pointer'>gaurav@i-am-peacekeeper.com</Link>
            </Typography>
          </Box>
        </Container>
      </Box> */}
      </Box>


      




    </>
  );
};

export default Events;
